module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('mu-appbar', [_c('span', {
    staticClass: "topT"
  }, [_vm._v("他人代付")]), _vm._v(" "), _c('mu-icon', {
    staticStyle: {
      "margin-bottom": "-0.05rem"
    },
    attrs: {
      "slot": "left",
      "value": "keyboard_arrow_left",
      "color": "white"
    },
    on: {
      "click": _vm.goback
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_left",
      "color": "#27ba69"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-top": "0.3rem"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('textarea', {
    staticStyle: {
      "resize": "none",
      "width": "92%",
      "height": "5.2rem",
      "font-size": "0.22rem",
      "padding": "0.15rem",
      "background-color": "#F6F6F6"
    },
    attrs: {
      "readonly": "",
      "id": "gxx1"
    }
  }, [_vm._v(_vm._s(_vm.payURL) + " ")]), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "font-size": "0.3rem",
      "margin-top": "0.2rem"
    },
    style: ({
      width: '92%',
      height: '0.8rem'
    }),
    attrs: {
      "data-clipboard-target": "#gxx1",
      "label": "双击选中后手动复制",
      "primary": ""
    },
    on: {
      "click": _vm.Copy
    }
  })], 1), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-deeb9ad6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/PayByOther.vue
// module id = 1603
// module chunks = 18